import useCurrentCompany from './useCurrentCompany';

export default useCurrentCompany;
